export const goalsStatus = [
  { label: "Active", value: "active" },
  { label: "Planned", value: "planned" },
  { label: "Completed", value: "completed" },
];

export const statusColor = {
  achieved: "statusBlock--success",
  missed: "statusBlock--failed",
  not_started: "statusBlock--purple",
  on_track: "statusBlock--pending",
  at_risk: "statusBlock--pending",
  off_track: "statusBlock--pending",
};
